/**
 * HarvestEventTypeSchemaEntityTypeName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EntityTypeName from '../EntityTypeName';

// // Selectors
import { makeSelectHarvestSchemaValue } from '../../services/schemas/selectors';

interface Props {
    entityTypeId?: number;
}

export class HarvestEventTypeSchemaEntityTypeName extends React.PureComponent<Props> {
    render() {
        const { entityTypeId } = this.props;
        return <EntityTypeName entityTypeId={entityTypeId} />;
    }
}

const mapStateToProps = createStructuredSelector({
    entityTypeId: makeSelectHarvestSchemaValue('entityTypeId')
});

export default connect(mapStateToProps)(HarvestEventTypeSchemaEntityTypeName);
